import React, { Component } from 'react';
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import FavoriKur from './../components/favorikur';
import Bant from './../components/bant';
import http from "./../services/httpService";
import config from "./../config.json";

const TOUR_SEEN_KEY = 'favTourSeen';

class FavorilerSayfa extends Component {
    state = {
        avalues: [],
        dvalues: [],
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        document.title = "Altınkaynak Şirketler Grubu - Canlı Favorilerim"

        // İlk ziyarette rehberli turu bir kez otomatik başlat.
        if (localStorage.getItem(TOUR_SEEN_KEY) !== '1') {
            this.tourTimeout = setTimeout(() => this.startTour(true), 900);
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        if (this.tourTimeout) clearTimeout(this.tourTimeout);
        if (this.driver && this.driver.isActivated) this.driver.reset(true);
    }

    startTour = (auto) => {
        // Hedef eleman hazır değilse (veri gelmemiş) otomatik turu başlatma.
        if (auto && !document.getElementById('fav-all')) {
            return;
        }

        // Tek bir Driver örneği oluşturup tekrar kullan (v0.9'da yeni örnek
        // yaratmak ikinci başlatmada düzgün render etmiyor).
        if (this.driver) {
            this.driver.reset(true);
            // Başlatmayı ertele: aksi halde butona tıklama olayı driver'ın
            // "dışarı tıklama = kapat" dinleyicisine ulaşıp turu hemen kapatıyor.
            setTimeout(() => this.driver.start(), 0);
            return;
        }

        this.driver = new Driver({
            className: 'ak-driver',
            animate: true,
            opacity: 0.7,
            padding: 10,
            allowClose: true,
            overlayClickNext: false,
            nextBtnText: 'İleri',
            prevBtnText: 'Geri',
            doneBtnText: 'Bitir',
            closeBtnText: '✕',
            onReset: () => { localStorage.setItem(TOUR_SEEN_KEY, '1'); }
        });

        this.driver.defineSteps([
            {
                element: '#fav-all',
                popover: {
                    title: 'Favorileriniz',
                    description: 'Takip etmek istediğiniz döviz ve altın kurlarını burada tek listede toplarsınız. Eklemek/çıkarmak için sağ üstteki ayar simgesini kullanın.',
                    position: 'bottom'
                }
            },
            {
                element: '#fav-all .fav-gear i',
                popover: {
                    title: 'Kur Seç',
                    description: 'Bu simgeye tıklayıp açılan listeden Döviz ve Altın gruplarından favorilerinizi seçin. Dilediğiniz zaman ekleyip çıkarın; en çok 15 kur ekleyebilirsiniz.',
                    position: 'left'
                }
            },
            {
                element: '#fav-all .table-responsive',
                popover: {
                    title: 'Sıralamayı Değiştir',
                    description: 'Kurları sürükleyip bırakarak istediğiniz sıraya dizebilirsiniz. Sıralamanız bu cihazda hatırlanır.',
                    position: 'top'
                }
            }
        ]);

        // Başlatmayı ertele (tıklama olayının turu hemen kapatmasını önler).
        setTimeout(() => this.driver.start(), 0);
    }

    async setValues(){

        if(JSON.parse(localStorage.getItem('avalues')) !== null){
            this.setState({avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues'))})
        }

        var {data : avalues} =  await http.get(config.restEndpoint + 'Gold');
        localStorage.setItem('avalues', JSON.stringify(avalues));
        var {data : dvalues} = await http.get(config.restEndpoint + 'Currency');
        localStorage.setItem('dvalues', JSON.stringify(dvalues));

        if(avalues !== null & dvalues !== null)
            this.setState({avalues,dvalues})
    }

    render() {
        return <div className="favori-page">
                <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
                <div className="row">
                    <div className="col-lg-12">
                        <FavoriKur avalues={this.state.avalues} dvalues={this.state.dvalues}/>
                    </div>
                </div>
                <div className="fav-tour-bar">
                    <button type="button" className="fav-tour-btn" onClick={() => this.startTour(false)}>
                        <i className="zmdi zmdi-help-outline"></i> Nasıl kullanılır?
                    </button>
                </div>
            </div>;
    }
}

export default FavorilerSayfa;
